"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgb2hex = rgb2hex;

/**
 * Converts RGB to HEX.
 * @param r Red.
 * @param g Green.
 * @param b Blue.
 */
function rgb2hex(r, g, b) {
  var hex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  return "#".concat(hex);
}